import { useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Paper, TextField, Button, Typography, Alert, Stack } from '@mui/material';
import { api } from '../api/client';

export function SetPasswordPage() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const token = useMemo(() => params.get('token') ?? '', [params]);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr(null);
    if (password.length < 12) { setErr('La contraseña debe tener al menos 12 caracteres'); return; }
    if (password !== confirm) { setErr('Las contraseñas no coinciden'); return; }
    setLoading(true);
    try {
      await api.post('/auth/set-password', { token, password });
      setSuccess(true);
      setTimeout(() => nav('/login'), 2000);
    } catch (e: unknown) {
      const ax = e as { response?: { data?: { message?: string } } };
      setErr(ax.response?.data?.message ?? 'No se pudo establecer la contraseña');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: 'background.default' }}>
      <Paper sx={{ p: 4, width: 420, maxWidth: '94vw' }} component="form" onSubmit={submit}>
        <Typography variant="h5" gutterBottom>Define tu contraseña</Typography>
        {!token && <Alert severity="error" sx={{ mb: 2 }}>Falta el token. Revisa el enlace recibido por email.</Alert>}
        {success && <Alert severity="success" sx={{ mb: 2 }}>Contraseña establecida. Redirigiendo a login…</Alert>}
        <Stack spacing={2}>
          {err && <Alert severity="error">{err}</Alert>}
          <TextField label="Contraseña" type="password" value={password}
                     onChange={(e) => setPassword(e.target.value)}
                     required fullWidth autoFocus disabled={!token || success}
                     helperText="Mínimo 12 caracteres" />
          <TextField label="Confirmar contraseña" type="password" value={confirm}
                     onChange={(e) => setConfirm(e.target.value)}
                     required fullWidth disabled={!token || success} />
          <Button type="submit" variant="contained" disabled={!token || loading || success} size="large">
            {loading ? 'Guardando…' : 'Activar cuenta'}
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
